import React, { Component } from "react";
import { connect } from 'react-redux';
import { fromJS } from 'immutable';
import { bindActionCreators } from 'redux'

import Form from './Form'
import ActionGet from '../../store/action/Supervisor/Fetch'
import ActionDelete from '../../store/action/Supervisor/Delete'
import CustomGridSearch from '../../infra/components/grid/custom-grid-with-search'
import "../../source/util.css"
import { IsEdit, IsCreate, IsView } from '../../store/constants'
import { toast } from "react-toastify";
import Swal from "sweetalert2";

class Page extends Component{
    constructor(props){
        super(props)
        this.state = {
            title: "Supervisor",
            form: fromJS({
                show : false,
                actionType: '',
                item: fromJS({})
            }),
            formSearch: fromJS({
                "search": ""
            }),
            search: fromJS([
                { widthClass:'col-sm-12', id: 'search', placeholder: 'Search', label : '', value:'' },
            ]),
            columns:[
                { className : "col-md-1", cfield: "counter", caption: "No" },
                { className : "", field: "spv-name", caption: "Name", allowSearch: true },
                { className : "col-md-2", cfield: "action", caption: "Actions", allowView: false }    
            ],
            errors: fromJS({})
        };
    
        this.showContent = this.showContent.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleNew = this.handleNew.bind(this);
        this.handleViewClicked = this.handleViewClicked.bind(this);
        this.handleEditClicked = this.handleEditClicked.bind(this);
        this.handleRemoveClicked = this.handleRemoveClicked.bind(this);
        this.handleCancelForm = this.handleCancelForm.bind(this);
        this.handlePageChanged = this.handlePageChanged.bind(this);
    }

    componentDidMount(){
        const { formSearch } = this.state;
        this.props.actionGet(1, formSearch);
    }

    handleSearch(obj){
        this.setState({ formSearch: obj });
        this.refreshGrid(1, obj);
    }

    handleCancelForm(refresh){
        if(refresh){
            this.props.actionGet();
        }
        this.setState({ 
            form:  fromJS({
                show: false,
                actionType: '',
                item: fromJS({})
            })
        })
    }

    handleNew(){
        this.setState({ 
            form:  fromJS({
                show: true,
                actionType: IsCreate,
                item: fromJS({})
            })
        })
    }

    handleViewClicked = (value) => {
        this.setState({ 
            form:  fromJS({
                show: true,
                actionType: IsView,
                item: value
            })
        })
    }

    handleEditClicked = (value) => {
        this.setState({ 
            form:  fromJS({
                show: true,
                actionType: IsEdit,
                item: value
            })
        })
    }

    handlePageChanged = (value) => {
        const { formSearch } = this.state;
        this.refreshGrid(value, formSearch);
    }


    refreshGrid(page, search){
        this.props.actionGet(page, search);
    }

    async handleRemoveClicked(value){
        var body = {
            "data":{
                "spv-id":value.get('spv-id')
            }
        };
        var temp = await this.props.actionDelete(body);
        if(temp.ok){
            Swal.fire("Deleted!", "Data has been deleted.", "success");
            toast.success('Delete '+ value.get('spv-name') +' Success!', toast.POSITION.TOP_RIGHT);
            this.refreshGrid(1, this.state.formSearch);
        }else{
            Swal.fire("Failed!", "Failed to delete data.", "error");
            toast.error('Delete '+ value.get('spv-name') +' Failed!', toast.POSITION.TOP_RIGHT);
        }
    }

    showContent(){
        var form = this.state.form;

        if(form.get('show')){
            return(
                <Form 
                    actionType={ form.get('actionType') }
                    item={ form.get('item') }
                    handleCancelForm={ this.handleCancelForm }
                    handleSubmitOnForm={ this.handleSubmitOnForm }
                >
                </Form>
            )
        }else{
            const items = this.props.supervisors ? fromJS(this.props.supervisors) : fromJS({});

            return (
                <CustomGridSearch 
                    title="Supervisor"
                    columns={ this.state.columns  } 
                    items={ items }  
                    search={ this.state.search }
                    handleNew={ this.handleNew }
                    handleSearch={ this.handleSearch }
                    handleViewClicked={this.handleViewClicked}
                    handleEditClicked={this.handleEditClicked}
                    handleRemoveClicked={this.handleRemoveClicked}
                    handlePageChanged={this.handlePageChanged}
                >
                </CustomGridSearch>
            )
        }
    }

    render(){
        const { form } = this.state;
        const title = form.get('show') ? ( form.get('actionType') === IsCreate ? "Add Supervisor"  : "Edit Supervisor"  ) : "Supervisor";
        return (
            <div className="clearfix">
            <div className="card-noborder">
                <h4>
                    { title }
                </h4>
            </div>
                {
                    this.showContent()
                }
            </div>
        );
    }
}


export default connect(
  (state) => {
      return {
        supervisors: state.user.supervisors,
      }
  },
  dispatch => bindActionCreators({
      actionGet: ActionGet,
      actionDelete: ActionDelete,
  }, dispatch),
)(Page);